export default __webpack_public_path__ + "static/meaningImg-15df7da70af84e5aa9ba125fd88a2928.png";